import apiInstance from "./apiInstance";

const addSmsTemplate = (postData) => {
  return apiInstance.post("sms/template", postData);
};

const editSmsTemplate = (postData) => {
  return apiInstance.put("sms/template", postData);
};

const deleteSmsTemplate = (postData) => {
  return apiInstance.delete(`sms/template/${postData}`);
};

const searchSmsTemplate = (searchCriteria) => {
  return apiInstance.post("sms/template/search", searchCriteria);
};

const addEmailTemplate = (postData) => {
  return apiInstance.post("mail/template", postData);
};

const editEmailTemplate = (postData) => {
  return apiInstance.put("mail/template", postData);
};

const deleteEmailTemplate = (postData) => {
  return apiInstance.delete(`mail/template/${postData}`);
};

const searchEmailTemplate = (searchCriteria) => {
  return apiInstance.post("mail/template/search", searchCriteria);
};

const addScreenMessage = (message) => {
  return apiInstance.post("message/screenmessage", message);
};

const addMultiScreenMessage = (message) => {
  return apiInstance.post("message/screenmessage/multi", message);
};

const addAnnounceMessage = (message) => {
  return apiInstance.post("message/announcement", message);
};

const addMailMessage = (postData) => {
  return apiInstance.post("mail/send ", postData);
};

const addScreenMessageTemplate = (postData) => {
  return apiInstance.post("screenmessage/template", postData);
};

const editScreenMessageTemplate = (postData) => {
  return apiInstance.put("screenmessage/template", postData);
};

const deleteScreenMessageTemplate = (postData) => {
  return apiInstance.delete(`screenmessage/template/${postData}`);
};

const searchScreenMessageTemplate = (searchCriteria) => {
  return apiInstance.post("screenmessage/template/search", searchCriteria);
};

const addAnnounceTemplate = (postData) => {
  return apiInstance.post("announcement/template", postData);
};

const editAnnounceMessageTemplate = (postData) => {
  return apiInstance.put("announcement/template", postData);
};

const deleteAnnounceMessageTemplate = (postData) => {
  return apiInstance.delete(`announcement/template/${postData}`);
};

const searchAnnounceMessageTemplate = (searchCriteria) => {
  return apiInstance.post("announcement/template/search", searchCriteria);
};

const getOutbox = () => {
  return apiInstance.get("postbox/outbox");
};

const getInbox = () => {
  return apiInstance.get("postbox/inbox");
};

const addMailSettings = (params) => {
  return apiInstance.post("mail/settings", params);
};

const updateMailSettings = (params) => {
  return apiInstance.put("mail/settings", params);
};

const getMailSettings = () => {
  return apiInstance.get("mail/settings");
};

const deleteMailSettings = (settingsId) => {
  return apiInstance.delete(`mail/settings/${settingsId}`);
};

const searchSmsHeaders = (params) => {
  return apiInstance.post(`sms/header/search`, params);
};

const getHeaderBySchoolId = (schoolId) => {
  return apiInstance.get(`sms/header/${schoolId}`);
};

const getHeaderByPermittedSchools = () => {
  return apiInstance.get(`sms/header/getAll`);
};

const addSmsHeaders = (params) => {
  return apiInstance.post(`sms/header`, params);
};

const deleteSmsHeaders = (headerId) => {
  return apiInstance.delete(`sms/header/${headerId}`);
};

const addSmsAnnouncement = (params) => {
  return apiInstance.post(`sms/send1n`, params);
};

const deleteInboxAnnouncement = (id) => {
  return apiInstance.delete(`announcement/inbox/${id}`);
};

const getSentMessage = () => {
  return apiInstance.post(`/message/getSentMessage`);
};

const searchTemplate = (params) => {
  return apiInstance.post(`message/template/search`, params);
};

const deleteTemplate = (templateId) => {
  return apiInstance.delete(`/message/template/${templateId}`);
};

const setMessageStatus = (params) => {
  return apiInstance.put(`/message/markmessage`, params);
};

const addMessageTemplate = (params) => {
  return apiInstance.post(`message/template`, params);
};

const deleteMessage = (messageId) => {
  return apiInstance.delete(`message/${messageId}`);
};

const deleteOutboxMessage = (messageId) => {
  return apiInstance.delete(`message/outbox/${messageId}`);
};

const postNotification = (params) => {
  return apiInstance.post(`/message/notification`, params);
};

const getMessageCount = () => {
  return apiInstance.get(`/message/search`);
};

const sendMultiSms = (params) => {
  return apiInstance.post(`/sms/send1nMulti`, params);
};

const deleteMessageFromInbox = (messageId) => {
  return apiInstance.delete(`/message/inbox/${messageId}`);
};

const sendEnteranceInfoSms = (sessionId) => {
  return apiInstance.get(`/sms/enteranceInfo/${sessionId}`);
};

const getMessageByUserId = (userId) => {
  return apiInstance.post(`/message/getUserIncomingMessages/${userId}`);
};

export {
  addSmsTemplate,
  editSmsTemplate,
  deleteSmsTemplate,
  searchSmsTemplate,
  addEmailTemplate,
  editEmailTemplate,
  deleteEmailTemplate,
  searchEmailTemplate,
  addScreenMessageTemplate,
  editScreenMessageTemplate,
  deleteScreenMessageTemplate,
  searchScreenMessageTemplate,
  addAnnounceTemplate,
  addScreenMessage,
  addMultiScreenMessage,
  addAnnounceMessage,
  editAnnounceMessageTemplate,
  deleteAnnounceMessageTemplate,
  searchAnnounceMessageTemplate,
  addMailMessage,
  getOutbox,
  getInbox,
  getMailSettings,
  addMailSettings,
  updateMailSettings,
  deleteMailSettings,
  searchSmsHeaders,
  addSmsHeaders,
  deleteSmsHeaders,
  addSmsAnnouncement,
  deleteInboxAnnouncement,
  searchTemplate,
  deleteTemplate,
  setMessageStatus,
  addMessageTemplate,
  deleteMessage,
  deleteOutboxMessage,
  getMessageCount,
  sendMultiSms,
  postNotification,
  deleteMessageFromInbox,
  getSentMessage,
  sendEnteranceInfoSms,
  getMessageByUserId,
  getHeaderBySchoolId,
  getHeaderByPermittedSchools
};
